













import { Component, Vue } from 'vue-property-decorator';
import PasswordField from './common/PasswordField.vue';
import CommonForm from './common/CommonForm.vue';

enum Headers {
  reviewLoginLinkError = 'Review Login Failed',
  authorizationError = 'Authorization Error'
}

@Component({
  components: {
    PasswordField,
    CommonForm
  }
})
export default class ErrorPage extends Vue {
  message = "We can't authorize you because of an error.";

  header = 'Authorization Error';

  created() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('message')) {
      this.message = urlParams.get('message') || this.message;
    }

    const meta = this.$route.meta || {};

    if (meta.header) {
      const metaHeader: keyof typeof Headers = meta.header;
      this.header = Headers[metaHeader] || Headers.authorizationError;
    }
  }
}
